<template>
    <div>
        <ds-modal
            :is-open="isOpen"
            show-close
            center
            :title="trackingCodeModalTitle"
            size="xl"
            @close="isOpen = false"
        >
            <div class="tracking-code">
                <div v-if="trackingCodeInfo.webTrackingDisabled">
                    <ds-inline-alert leading-icon type="warning">
                        {{ $options.WEB_TRACKING_DISABLED }}
                    </ds-inline-alert>
                </div>

                <div>
                    <b>{{ $options.INSTRUCTION }}</b>
                </div>

                <div class="tracking-code-info">
                    <span>
                        {{ $options.DESCRIPTION }}
                    </span>
                    <span @click="copyTrackingCode">
                        <a><ds-icon class="option-icon" name="copy" /></a>
                    </span>
                    <a :href="trackingCodeInfo.helpArticleLink" target="_blank">{{ $options.HELPLINK }}</a>
                </div>

                <ds-text-area-field
                    v-model="trackingCodeInfo.trackingCode"
                    readonly
                    name="basic"
                    :label="$options.LABEL"
                />
            </div>
        </ds-modal>

        <input ref="elTrackingCodeCopyFlag" type="textarea" @focus="$event.target.select()" />
    </div>
</template>

<script>
import axios from 'axios';

export const WEB_TRACKING_DISABLED = 'Your Web Tracking is currently disabled. Please contact Customer Support to be reactivated.';
export const INSTRUCTION = 'Paste this code on your site';
export const DESCRIPTION = 'Copy the following code, then paste it onto every page you want to track immediately before the closing body tag.';
export const HELPLINK = 'Need more info?';
export const LABEL = 'Code';

export default {
    WEB_TRACKING_DISABLED,
    INSTRUCTION,
    DESCRIPTION,
    HELPLINK,
    LABEL,

    props: {
        trackingCodeModalTitle: String,
    },

    data() {
        return {
            trackingCodeInfo: {},
            isOpen: false,
        };
    },

    created() {
        this.loadTrackingCode();
    },

    methods: {
        async loadTrackingCode() {
            try {
                const response = await axios.get('/app/webTracking/getTrackingCodeModalInfo');

                this.trackingCodeInfo = response.data;
            } catch (e) {
                this.$error({ message: 'Unable to get web tracking code' });
            }
        },

        showModal() {
            this.isOpen = true;
        },

        copyTrackingCode() {
            this.$refs.elTrackingCodeCopyFlag.value = this.trackingCodeInfo.trackingCode;
            this.$refs.elTrackingCodeCopyFlag.focus();

            document.execCommand('copy');

            // eslint-disable-next-line no-alert
            alert('Tracking code copied to clipboard');
        },
    },
};
</script>

<style lang="scss" scoped>
.tracking-code {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 200px;
}

.tracking-code-info {
    display: flex;
    justify-content: space-between;
    margin-top: $spacing-100;
    margin-bottom: $spacing-100;
}

</style>
